<template>
  <div id="color">
    <div class="color_title text_size_middle bold">
      <label>{{title}}</label>
    </div>
    <div class="color_img">
      <img v-if="color.imgB !== undefined" :src="color.imgB">
    </div>
    <div class="color_name">
      <label>{{color.name}}</label>
    </div>
  </div>
</template>
<script>
// Module

export default {
  name: 'Color',
  components: {
  },
  props: {
    title: String,
    color: Object
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style src="../../../../css/dcstyle.scss" lang="scss" scoped></style>
<style src="../../../../css/dc-common.scss" lang="scss" scoped></style>
<style src="../../../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/color/DcColor.vue